import Cookies from 'js-cookie';

import { getVueTemplate, getResourceUrlForMarketoDetailIdUrl } from '../../../_imports/utils/utils.common';

import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
import SeeMoreContent from "../../resource-page/_imports/see-more-content.vue.js";
import VideoChapters from '../../resource-page/_imports/video-chapters.vue';
import VideoTranscript from '../../resource-page/_imports/video-transcript.vue';
import MarketoForm from '../../../forms/_imports/marketo-form.vue';
import Modal from '../../../modal/modal.vue';
import ResourceVideo from '../../shared/resource-video.common';
import SeriesPagination from './series-pagination.vue';
import { renderPositionTitle } from '../../../members/_imports/person.common.js';

const componentName = 'resource-video-pop-up';

export default {
    mixins: [BaseVueComponent, SeeMoreContent, ResourceVideo],
    components: {
        VideoChapters,
        VideoTranscript,
        MarketoForm,
        Modal,
        SeriesPagination
    },
    template: getVueTemplate(componentName),
    props: {
        resource: {
            type: Object,
            required: true
        },
        formProps: {
            type: Object,
            required: true
        },
        displayPagination: {
            type: Boolean,
            required: false,
            default: false
        },
        displayPreviousArrow: {
            type: Boolean,
            required: false,
            default: false
        },
        displayNextArrow: {
            type: Boolean,
            required: false,
            default: false
        },
        previousResourceThumbnailUrl: {
            type: String,
            required: false,
        },
        nextResourceThumbnailUrl: {
            type: String,
            required: false,
        }
    },
    computed: {
        showGatedOverlay() {
            return this.isGated && !this.hasMarketoCookie();
        },
        renderTitle() {
            if(!this.resource.title || this.resource.title === '') {
                return this.resource.video.title;
            }

            return this.resource.title;
        },
        renderCreationDate() {
            return this.resource.video.createdAt.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        },
        renderDescription() {
            return this.resource.description || 
                   this.resource.shortDescription || 
                   this.resource.video?.description || 
                   '';
        },
        form() {
            return this.formProps.form;
        },
        overrideThankYouMessage() {
            return this.formProps.overrideThankYouMessage;
        },
        overrideFormTitle() {   
            return this.formProps.overrideFormTitle;
        },
        overrideMarketoDetailIDUrl() {
            return this.formProps.overrideMarketoDetailIDUrl;
        },
        showSeeMore() {
            return (this.renderDescription?.trim()?.length || 0) > 600;
        },
        hasSpeakers() {
            return this.resource.speakers && this.resource.speakers.people && this.resource.speakers.people.length;
        },
        isResourceVideo() {
            return this.resource.video && this.resource.videoId;
        },
        isGated() {
            return this.resource && this.resource.gatedContent === 'always';
        },
        showOverviewTab() {
            return this.renderDescription && this.renderDescription.length > 0;
        },
        paginationButtons() {
            return [
                {
                    direction: 'previous',
                    label: 'Previous',
                    isVisible: this.displayPreviousArrow
                },
                {
                    direction: 'next',
                    label: 'Next',
                    isVisible: this.displayNextArrow
                }
            ];
        }
    },
    methods: {
        ctaClick() {
            if (this.ctaClickAfterCloseModal) {
                this.ctaClickAfterCloseModal = false;
                return;
            }

            let shouldOpenResource = false;

            if (this.isGated) {
                if (this.hasMarketoCookie()
                    && CoveoWebsite.forms.email) {
                        shouldOpenResource = true;
                } else if (this.$refs.gatingFormModal) {
                    this.$refs.gatingFormModal.open();
                }
            } else {
                shouldOpenResource = true;
            }

            if (shouldOpenResource) {
                this.openResource();
            }
        },
        triggerFormModalClose() {
            this.$refs.gatingFormModal.close();
        },
        updateMarketoLeadAndPushDataLayer() {
            if (this.hasMarketoCookie() && !this.resourceIsOpened && Cookies.get('marketo_id') !== 'ot') {
                const config = {
                    resource: this.resource,
                    marketoDetailIDUrl: getResourceUrlForMarketoDetailIdUrl(this.resource)
                };

                this.updateMarketoLeadAndPushDataLayerCore(config, this.getPageId());
            }
        },
        getPageId() {
            let id = this.$el.id;

            if(!id || id === '') {
                const pageId = document.documentElement.getAttribute('page-id');
                if (pageId) {
                    id = pageId.replace(/-/g, '').toUpperCase();
                }
            }

            return id;
        },
        closePopUpModal() {
            this.resourceIsOpened = false;
            
            if(this.$refs.gatingFormModal?.$el){ 
                this.$refs.gatingFormModal.$el.remove();
            }

            this.$emit('closePopUpModal');
        },
        triggerPagination(direction) {
            if(direction === 'next') {
                this.$emit('triggerPagination', 'next');
            } else {
                this.$emit('triggerPagination', 'previous');
            }
        },
        cleanupGatingFormModal() {
            if (this.$refs.gatingFormModal?.$el) {
                this.$refs.gatingFormModal.close();
                this.$refs.gatingFormModal.$el.remove();
            }
        },
        renderSpeakerPositionTitle(speaker) {
            return renderPositionTitle({
                person: speaker,
                includeCompanyName: true
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this.resourceCanBeViewed) {
                this.openResource();
            }
        });
    },
    watch: {
        fullyLoaded() {
            setTimeout(() => {
                this.$root.$on("successMessage", (data) => {
                    this.successMessage = data;
                });

                this.$root.$on("get-lead-success", () => {
                    this.getLeadSuccess = true;
                });

                this.$root.$on("show-form-fields-animation-begin", () => {
                    this.formFieldsVisible = true;

                    if(!this.getLeadSuccess && window.innerWidth > 1024) {
                        Velocity(document.body, 'scroll', {
                            duration: 1200,
                            easing: [1000, 80],
                            offset: 140,
                            complete: () => {
                                this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
                            }
                        });
                    } else if(!this.getLeadSuccess) {
                        this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
                    }
                });
            }, 0);
        }
    },
    created() {
        this.provider = this.resource.video.provider;
        this.resourceCanBeViewed = !!(!this.isGated || (this.hasMarketoCookie() && CoveoWebsite.forms.email));   
    }
}